import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogClose } from './ui/dialog';

export const SettingsPanel = ({ open, onOpenChange, title, children }) => {
  const [mobile, setMobile] = useState(() => window.matchMedia('(max-width: 1000px)').matches);
  useEffect(() => {
    const media = window.matchMedia('(max-width: 1000px)');
    const change = () => setMobile(media.matches);
    media.addEventListener('change', change);
    return () => media.removeEventListener('change', change);
  }, []);
  if (!mobile) return <aside className="config-sidebar" data-testid="config-sidebar">{children}</aside>;
  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="settings-sheet" data-testid="config-sidebar" aria-describedby={undefined} onCloseAutoFocus={event => {
      event.preventDefault();
      document.querySelector('[data-testid="open-config-editor"], [data-testid="photo-stage-editor"]')?.focus();
    }}>
      <div className="settings-sheet-header"><DialogTitle data-testid="settings-sheet-title">{title}</DialogTitle><DialogClose className="settings-done" data-testid="close-config-editor">Done</DialogClose></div>
      <div className="settings-sheet-scroll">{children}</div>
    </DialogContent>
  </Dialog>;
};